<template>
  <div class="full-height">
    <foobar-header></foobar-header>
    <intro></intro>
    <section-intro :title="$t('message.title.main.about_foobar')"></section-intro>
    <about-foobar></about-foobar>
    <foobar-footer></foobar-footer>
  </div>
</template>

<script>
  import Intro from '@/components/partials/IntroLarge'
  import FoobarHeader from '@/components/partials/Header'
  import FoobarFooter from '@/components/partials/Footer'
  import AboutFoobar from '@/components/about/AboutFoobar'
  import SectionIntro from '@/components/partials/SectionIntroZeroOne'

  export default {
    components: {
      Intro,
      FoobarFooter,
      FoobarHeader,
      AboutFoobar,
      SectionIntro
    }
  }
</script>



// WEBPACK FOOTER //
// AboutFoobar.vue?17d875d9